import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ALL_ACTIVATED_STATUS } from "../../../helper/activatedStatus";


type ProductCodeFilterProps = {
  onChange: (value: string[]) => void;
  value?: string[];
};

export const StatusTypeFilter: React.FC<ProductCodeFilterProps> = ({
  value,
  onChange,
}) => {
  const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;
  const { t } = useTranslation();
  //const {allStatusTypes} = ;
  const allStatusTypes = ALL_ACTIVATED_STATUS

  const statusOptions = (allStatusTypes).split(",").map(
    (status) => {

      return ({
        value: status,
        label: t(`licenses.basic.status_type.${status}` as any),
        // label: activatedStatusIdToName(Number(status))
      })
    }
  );
  return (
    <SelectBoxWrapper>
      <Select
        mode="multiple"
        allowClear
        placeholder={t("licenses.basic.search.status.title")}
        style={{ width: "100%" }}
        maxTagCount={1}
        options={statusOptions}
        onChange={onChange}
        value={value}
      />
    </SelectBoxWrapper>
  );
};
